/**
@license
Copyright (c) 2023 Advensys LLC. All rights reserved.
*/


import {  LitElement, html, css } from 'lit';

import { connect } from 'pwa-helpers/connect-mixin.js';


// These are the shared styles needed by this element.
import { SharedStyles } from './shared-styles.js';

import { store } from '../store.js';
import {  signEnd, saveUser } from '../reducers/authSlice.js';
import {dataurl} from './paksh-constants.js'  // Import used to separate development urls from production


class UserProfile extends connect(store)(LitElement) {
  static get properties() {
    return {
      data: { type: Object },
      _user: { type: Object},
    };
  }

  static get styles() {
    return [
      SharedStyles,
      css`
      .userimage {
        height: 48px;
        border-radius: 50%;
      }

      section {
        border-bottom: 1px solid #eee;
      }

      .opace {
        opacity: 0;
      }

      #preview  {
        width:160px; /* or whatever width you want. */
        max-width:160px; /* or whatever width you want. */
        max-height:160px;
        height:160px; /* or whatever width you want. */
        display: inline-block;
        object-fit: cover;
        border: "solid 1px #CCC";
      }

      .sizer {
        object-fit: cover;
        width:  100%;
        height: auto;
        border: "solid 1px #CCC";
      }

      `
    ];
  }

  render() {
    const {
      _user,
      data
    } = this;


  return html` ${_user === undefined ? "" :html`

        <div>
          <md-outlined-text-field label='Enrollment Number' id='enrollnum' value="${('enrollnum' in this._user) ? this._user.enrollnum : ''}"  supporting-text="Enter your enrollment number issued by Bar council e.g. MAH/12/11234" >
            <md-icon slot="leadingicon">tag</md-icon>
          </md-outlined-text-field>
          <md-outlined-text-field label='Linkedin' id='linkedin'  value="${('linkedinUrl' in this._user) ? this._user.linkedinUrl : ''}" type='url'  supporting-text="Click the  Me icon at the top of your LinkedIn homepage.
            Your linkedin public profile URL. It'll be an address that starts with www.linkedin.com/in." >
            <md-icon slot="leading-icon">link</md-icon>
          </md-outlined-text-field>
          <md-outlined-text-field outlined label='Facebook' id='meta' value="${('fbUrl' in this._user) ? this._user.fbUrl : ''}" type='url' supporting-text="Your Facebook profile URL" >
            <md-icon slot="leadingicon">link</md-icon>
          </md-outlined-text-field>
          <md-outlined-text-field outlined label='Twitter' id='twitter'  type='url' value="${('twitterUrl' in this._user) ? this._user.twitterUrl : ''}" supporting-text="Your Twitter profile URL" >
          <md-icon slot="leadingicon">link</md-icon>
          </md-outlined-text-field>
          <md-outlined-text-field outlined label='Company' id='company'  value="${('company' in this._user) ? this._user.company : ''}" >
          <md-icon slot="leadingicon">business</md-icon>
          </md-outlined-text-field>
          <md-outlined-text-field outlined label='Address' id='address'  value="${('address' in this._user) ? this._user.address : ''}" supporting-text="Flat Number, Building Name
            Street Number, Street Name, Locality or Neighbourhood, CITY - Postal Code (PIN) State" >
            <md-icon slot="leadingicon">edit_location</md-icon>
          </md-outlined-text-field>
          <md-outlined-text-field outlined label='Mobile' id='phone'  type='tel'  value="${('mobile' in this._user) ? this._user.mobile : ''}" supporting-text="Mobile #"  >
          <md-icon slot="leadingicon">call</md-icon>
          </md-outlined-text-field>
          <md-outlined-text-field outlined label='Email' id='email'  type='email'  value="${('email' in this._user) ? this._user.email : ''}" supporting-text="Enter your primary email" >
          <md-icon slot="leadingicon">mail_outline</md-icon>
          </md-outlined-text-field>
          <div>
          <!--md-outlined-button><label for="image_uploads">Upload profile Image jpg or jpeg</label></md-outlined-button>
          <input  type="file" class="opace" id="image_uploads" name="image_uploads" accept=".jpg, .jpeg, .png"  @change=${e => this._updateImageDisplay(e)}>
          </div>
          <div id="preview">
            <p>No files currently selected for upload</p>
          </div>

  <md-outlined-button label="Save" @click="${() => this._submitProfile()}"  dialogAction="close"></md-outlined-button>
        </div-->
     `
    }`
  }

  firstUpdated() {
    //console.log(this._user)


  }

  _updateImageDisplay(e) {
    const preview = this.renderRoot.querySelector('#preview');
    const input = this.renderRoot.querySelector('#image_uploads');
    console.log("in update")
    while(preview.firstChild) {
      preview.removeChild(preview.firstChild);
    }

    const curFiles = input.files;
    if(curFiles.length === 0) {
      const para = document.createElement('p');
      console.log("in update2")
      para.textContent = 'No files currently selected for upload';
      preview.appendChild(para);
    } else {

      //const list = document.createElement('ol');
      //preview.appendChild(list);

      for(const file of curFiles) {

        //const listItem = document.createElement('li');
        const para = document.createElement('p');
        if(this._validFileType(file)) {
          console.log(URL.createObjectURL(file))
          const image = document.createElement('img');
          image.src = URL.createObjectURL(file);
          image.className= "sizer";
          preview.appendChild(image);
          //preview.style.backgroundImage=URL.createObjectURL(file);
          preview.style.backgroundColor="RED";
          /*para.textContent = `File name ${file.name}, file size ${this._returnFileSize(file.size)}.`;
          const image = document.createElement('img');
          image.src = URL.createObjectURL(file);
          image.class= "sizer";
          listItem.appendChild(image);
          listItem.appendChild(para); */
        } else {
          para.textContent = `File name ${file.name}: Not a valid file type. Update your selection.`;
          listItem.appendChild(para);
        }

        //list.appendChild(listItem);
      }
    }
  }

  _returnFileSize(number) {
    console.log("filesize")
    if(number < 1024) {
      return number + 'bytes';
    } else if(number >= 1024 && number < 1048576) {
      return (number/1024).toFixed(1) + 'KB';
    } else if(number >= 1048576) {
      return (number/1048576).toFixed(1) + 'MB';
    }
  }

  _validFileType(file) {
    console.log("valid")
  const fileTypes = [
    "image/apng",
    "image/bmp",
    "image/gif",
    "image/jpeg",
    "image/pjpeg",
    "image/png",
    "image/svg+xml",
    "image/tiff",
    "image/webp",
    "image/x-icon"
  ];


    return fileTypes.includes(file.type);
  }


  stateChanged(state) {
    this._user = state.auth.user;

  }

//-- ClosePopup and reflect in state
  _closePopup() {
    //store.dispatch(updateRightDrawerState(false));
    //let el=this.shadowRoot.querySelector("#profiledialog");
    //el.close();
  }

// --- Close popup and signout
  _logOut() {
    console.log("heeeeee")
    store.dispatch(signOut());
    this._closePopup();
  }

  _calcCost(e) {
    this._subscriptionValue=e.target.value;
    if (e == "payperview") {
      this._cost="Cost: ₹400 per view";
    }
    else if (e == "all") {
      this._cost="Cost:  ₹4,000 per month";
    }
    else {
      this._cost="Cost:  ₹1,000 per month per court";
    }

  }

  _setCourt(e){
    this._courtValue=e.target.value;
  }



  _submitProfile() {

    let data = this._user
    data ["court"] = this._courtValue;
    data ["subscription"] = this._subscriptionValue;
    data ["enrollnum"] = this.shadowRoot.querySelector('#enrollnum').value;
    data ["linkedinUrl"] = this.shadowRoot.querySelector('#linkedin').value;
    data ["fbUrl"] = this.shadowRoot.querySelector('#meta').value;
    data ["twitterUrl"] = this.shadowRoot.querySelector('#twitter').value;
    data ["address"] = this.shadowRoot.querySelector('#address').value;
    data ["mobile"] = this.shadowRoot.querySelector('#phone').value;
    data ["email"] = this.shadowRoot.querySelector('#email').value;
    // data ["lastColorId"] = this.shadowRoot.querySelector('#lastColorId').value;
    //console.log("before dispatch save user")
    //console.log(data)
    store.dispatch(saveUser(this._user.uid, data));
    this._closePopup()
  }


}

window.customElements.define('user-profile', UserProfile);
